module.exports = __webpack_public_path__ + "static/media/dikshit_portfolio.fdad04d3.jpeg";